import { SVGProps } from 'react';
import cn from 'classnames';
import { SvgType } from '@/shared/types/common';
import styles from './Svg.module.scss';

export interface SvgProps extends SVGProps<SVGSVGElement> {
  Icon: SvgType;
  needRotate?: true;
  className?: string;
  width?: number | string;
  height?: number | string;
}

export const Svg = ({
  className,
  Icon,
  needRotate,
  width = 24,
  height = 24,
  ...rest
}: SvgProps) => {
  if (typeof Icon === 'string') {
    return <img src={Icon} alt="" className={className} width={width} height={height} />;
  }
  const IconComponent = Icon as React.FC<React.SVGProps<SVGSVGElement>>;
  return (
    <IconComponent
      className={cn('icon', styles.root, { [styles.rotate]: needRotate }, className)}
      width={width}
      height={height}
      {...rest}
    />
  );
};
